import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { MsalBroadcastService } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';
import { filter, map, switchMap, take } from 'rxjs/operators';

import { AuthAccessService } from './auth-access.service';

export const authAccessGuard: CanActivateFn = () => {
  const accessService = inject(AuthAccessService);
  const msalBroadcastService = inject(MsalBroadcastService);
  const router = inject(Router);

  return msalBroadcastService.inProgress$.pipe(
    filter((status) => status === InteractionStatus.None),
    take(1),
    switchMap(() => accessService.hasAccess()),
    map((hasAccess) => (hasAccess ? true : router.createUrlTree(['/unauthorized']))),
  );
};

export const authAccessChildGuard: CanActivateChildFn = (route, state) => authAccessGuard(route, state);
